import { useState } from 'react';
import { DateInputOld2 as DateInput2 } from '../../../../common/Input';
import { FailMessage } from '../../../../common/APICommon';

export const AddUpdateTrainingModal = ({
  visible,
  onClose,
  onSave,
  modalName,
  title, setTitle,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
  file, setFile,
  fileName, setFileName,
}) => {
  const [failMessage, setFailMessage] = useState("");

  if (!visible) return null;

  // for upload: Updates the 'file' prop state in the parent
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    setFile(selectedFile);
    setFileName(selectedFile.name);
  };

  const handleSubmit = async () => {
    // Validation check
    if (!title || !dateFrom || !dateTo) {
      setFailMessage(`Please fill up required field/s.`);
      return;
    }

    // Calls handleAddData or handleUpdateData from the parent
    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
    setTitle("");
    setDateFrom(null);
    setDateTo(null);
    setFile([]);
    setFileName(null);
    setFailMessage("")
  }

  const closeModal = () => {
    onClose(); // This also triggers the parent's resetAllValues
    resetLocalVariables();
  }
  return (
    <>
      <div className={`modal-overlay ${visible ? 'open' : ''}`}>
        {visible && (
          <div className="modal">
            <div id="education-form" className="add-employees-form">
              <div className="popUp-header row">
                <div className='popUp-title'><h3 style={{ color: "#668fca" }}>{modalName}</h3></div>
                {/* <div className='popUp-close'><CloseIcon onClick={()=>handleClose()}/></div> */}
              </div>
              <div className="popUp-body">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">title</div>
                  <div className="info-item-input"><input id="AddEmployee-Title" value={title} placeholder="Title" onChange={(e) => setTitle(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateInput2 id="Education-DateFrom" value={dateFrom} onChange={(value) => setDateFrom(value)} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateInput2 id="Education-DateTo" value={dateTo} onChange={(value) => setDateTo(value)} />
                  </div>
                </div>
                <div>
                  <label className="mb-1 block text-sm font-medium">
                    File
                  </label>
                  <div className="info-item-input">
                    <label htmlFor="file-input" className='column' style={{
                      color: "#808080b5",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer" // Add cursor pointer for better user interaction
                    }}>
                      {!file && <img src={"images/upload-image.png"} alt="" style={{ width: "auto", height: "200px" }}></img>}
                      {file ? file.name : "Click the placeholder to upload a logo"}
                    </label>
                    <input
                      id="file-input"
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </div>
                  <span style={{
                    visibility: "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>

                  {file &&
                    <>
                      <div className='w-full'>
                        <button
                          className={"bg-blue-500 hover:bg-blue-600 border-none cursor-pointer p-1 px-2 text-white my-1 rounded-sm"}
                          onClick={() => {
                            const url = URL.createObjectURL(file); // create a blob URL
                            const link = document.createElement("a");
                            link.href = url;
                            link.download = file.name || "download"; // use file name if available
                            link.click();
                            URL.revokeObjectURL(url); // cleanup
                          }}
                        >
                          View File
                        </button>
                      </div>
                    </>}
                </div>
                <div className="educations-tab-footer tab-footer">
                  <div className="buttons row" style={{ justifyContent: "end" }}>
                    <button id="add-education"
                      className="save row"
                      onClick={handleSubmit}>
                      SAVE
                    </button>
                    <button id="add-education"
                      className="cancel row"
                      onClick={closeModal}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Assuming FailMessage is imported */}
      <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
    </>
  );
};
